import * as Alert from '../../utils/Alerts';
import axios from "axios";
import { all, put, takeLatest } from 'redux-saga/effects';
import { getClients as getClientsQuery } from '../graphql/queries';
import {
  updateUserLanguageSettings as updateUser,
} from '../graphql/userSettingsMutations';
import { updateLanguage } from '../actions/UserSettingsActions';
import { graphQLEndpoint } from '../settings';
import { getHeaders } from './Helper';
import { USER_SETTINGS } from '../actions/UserSettingsActions';
import { setUsersLanguage } from '../actions/UserActions';

export function* updateUserSettingsSaga({ payload: { language } }) {
  try {
    const query = updateUser(language);
    const body = JSON.stringify({query});
    const headers = yield getHeaders();
    const response = yield axios.post(
      graphQLEndpoint,
      body,
      headers
    )
    console.log(response)
    if (response?.data?.errors) {
      throw new Error(response?.data?.errors[0]?.message);
    }

    yield put(updateLanguage.success(response?.data?.data?.updateLanguage));
    yield put(setUsersLanguage(response?.data?.data?.updateUserLanguageSettings?.userSettings));
    yield Alert.setSuccessAlert("UI jezik uspešno izmenjen");
  } catch (e) {
    console.log(e)
    yield put(updateLanguage.failure(e));
    yield Alert.setErrorAlert("Desila se greška pri izmeni klijenta");
  }
}

function* userSettingsSaga() {
  yield all([
    //takeLatest(USER_SETTINGS.GET.REQUEST, getClientsSaga),
    //takeLatest(CLIENT.POST.REQUEST, createClientSaga),
    //takeLatest(CLIENT.DELETE.REQUEST, deleteClientSaga),
    takeLatest(USER_SETTINGS.PUT.REQUEST, updateUserSettingsSaga)
  ])
}
  
export default userSettingsSaga;
